var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { fetchProfile, updateProfile, uploadLogo, deleteLogo } from '@/lib/api';
import { useI18n } from '@/lib/i18n';
import * as styles from './BrandingSettings.module.scss';
var BASIC_COLORS = ['#6366f1', '#ec4899', '#14b8a6', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4'];
var PRO_GRADIENTS = [
    { id: 'sunset', value: 'linear-gradient(135deg, #f093fb, #f5576c)' },
    { id: 'ocean', value: 'linear-gradient(135deg, #4facfe, #00f2fe)' },
    { id: 'aurora', value: 'linear-gradient(135deg, #a18cd1, #fbc2eb)' },
    { id: 'emerald', value: 'linear-gradient(135deg, #11998e, #38ef7d)' },
    { id: 'fire', value: 'linear-gradient(135deg, #f12711, #f5af19)' },
    { id: 'midnight', value: 'linear-gradient(135deg, #0f0c29, #302b63, #24243e)' },
    { id: 'candy', value: 'linear-gradient(135deg, #fc5c7d, #6a82fb)' },
    { id: 'forest', value: 'linear-gradient(135deg, #134e5e, #71b280)' },
    { id: 'royal', value: 'linear-gradient(135deg, #141e30, #243b55)' },
    { id: 'neon', value: 'linear-gradient(135deg, #b721ff, #21d4fd)' },
];
export var BrandingSettings = function (_a) {
    var isPro = _a.isPro, onUpgrade = _a.onUpgrade;
    var _b = useI18n(), t = _b.t, locale = _b.locale;
    var _c = useState(''), companyName = _c[0], setCompanyName = _c[1];
    var _d = useState('#6366f1'), brandColor = _d[0], setBrandColor = _d[1];
    var _e = useState(null), logoUrl = _e[0], setLogoUrl = _e[1];
    var _f = useState(false), saving = _f[0], setSaving = _f[1];
    var _g = useState(false), uploading = _g[0], setUploading = _g[1];
    var _h = useState(false), saved = _h[0], setSaved = _h[1];
    var fileInputRef = useRef(null);
    var isGradient = brandColor.startsWith('linear-gradient');
    useEffect(function () { if (isPro)
        loadBranding(); }, [isPro]);
    var loadBranding = function () { return __awaiter(void 0, void 0, void 0, function () {
        var profile, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchProfile()];
                case 1:
                    profile = _a.sent();
                    if (profile) {
                        setCompanyName(profile.company_name || '');
                        setBrandColor(profile.brand_color || '#6366f1');
                        setLogoUrl(profile.logo_url || null);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updateProfile({ company_name: companyName, brand_color: brandColor })];
                case 2:
                    _a.sent();
                    setSaved(true);
                    setTimeout(function () { return setSaved(false); }, 2000);
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _a.sent();
                    console.error(err_2);
                    return [3 /*break*/, 5];
                case 4:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleLogoUpload = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var file, _a, err_3;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    file = (_b = e.target.files) === null || _b === void 0 ? void 0 : _b[0];
                    if (!file)
                        return [2 /*return*/];
                    setUploading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    _a = setLogoUrl;
                    return [4 /*yield*/, uploadLogo(file)];
                case 2:
                    _a.apply(void 0, [_c.sent()]);
                    return [3 /*break*/, 5];
                case 3:
                    err_3 = _c.sent();
                    console.error(err_3);
                    return [3 /*break*/, 5];
                case 4:
                    setUploading(false);
                    if (fileInputRef.current)
                        fileInputRef.current.value = '';
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteLogo = function () { return __awaiter(void 0, void 0, void 0, function () { var err_4; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, deleteLogo()];
            case 1:
                _a.sent();
                setLogoUrl(null);
                return [3 /*break*/, 3];
            case 2:
                err_4 = _a.sent();
                console.error(err_4);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    }); }); };
    var l = {
        title: locale === 'ru' ? '🎨 Брендинг портала' : '🎨 Portal Branding',
        subtitlePro: locale === 'ru' ? 'Настройте внешний вид портала для ваших клиентов' : 'Customize the look of your client portal',
        subtitleFree: locale === 'ru' ? 'Ваш портал будет выглядеть как собственный продукт — с логотипом, градиентами и названием' : 'Your portal will look like your own product — with logo, gradients and company name',
        logo: locale === 'ru' ? 'Логотип' : 'Logo',
        uploadLogo: locale === 'ru' ? '📁 Загрузить логотип' : '📁 Upload Logo',
        uploading: locale === 'ru' ? '⏳ Загрузка...' : '⏳ Uploading...',
        logoHint: locale === 'ru' ? 'PNG, JPG или SVG, до 2 МБ' : 'PNG, JPG or SVG, up to 2 MB',
        replace: locale === 'ru' ? 'Заменить' : 'Replace',
        remove: locale === 'ru' ? 'Удалить' : 'Remove',
        brandColor: locale === 'ru' ? 'Цвет бренда' : 'Brand Color',
        customColor: locale === 'ru' ? 'Свой цвет' : 'Custom color',
        preview: locale === 'ru' ? 'Предпросмотр шапки портала:' : 'Portal header preview:',
        lockTitle: locale === 'ru' ? 'Доступно на Pro' : 'Available on Pro',
        lockText: locale === 'ru' ? 'Логотип, фирменные градиенты и название компании — клиенты увидят ваш бренд, а не ClientBase' : 'Logo, gradients and company name — clients see your brand, not ClientBase',
        unlock: locale === 'ru' ? '⭐ Разблокировать за 4 $/мес' : '⭐ Unlock for $4/mo',
    };
    return (_jsxs("div", { className: styles.wrapper, children: [_jsxs("div", { className: styles.sectionHeader, children: [_jsxs("div", { className: styles.title, children: [l.title, !isPro && _jsx("span", { className: styles.proBadge, children: "PRO" })] }), _jsx("div", { className: styles.subtitle, children: isPro ? l.subtitlePro : l.subtitleFree })] }), _jsxs("div", { className: styles.contentArea, children: [!isPro && (_jsx("div", { className: styles.lockOverlay, children: _jsxs("div", { className: styles.lockCard, children: [_jsx("div", { className: styles.lockIcon, children: "\uD83D\uDD12" }), _jsx("div", { className: styles.lockTitle, children: l.lockTitle }), _jsx("div", { className: styles.lockText, children: l.lockText }), _jsx("button", { className: styles.unlockBtn, onClick: onUpgrade, children: l.unlock })] }) })), _jsxs("div", { className: !isPro ? styles.blurred : undefined, children: [_jsxs("div", { className: styles.grid, children: [_jsxs("div", { className: styles.card, children: [_jsx("div", { className: styles.label, children: l.logo }), isPro && logoUrl ? (_jsxs("div", { className: styles.logoPreview, children: [_jsx("img", { src: logoUrl, alt: "Logo", className: styles.logoImg }), _jsxs("div", { className: styles.logoActions, children: [_jsx("button", { className: styles.changeLogo, onClick: function () { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, children: l.replace }), _jsx("button", { className: styles.removeLogo, onClick: handleDeleteLogo, children: l.remove })] })] })) : (_jsxs("div", { className: styles.logoPlaceholder, children: [_jsx("span", { className: styles.logoPlaceholderIcon, children: "\uD83D\uDCC1" }), _jsx("span", { children: isPro ? l.uploadLogo : t.logoPlaceholder })] })), isPro && !logoUrl && (_jsx("button", { className: styles.uploadBtn, onClick: function () { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, disabled: uploading, children: uploading ? l.uploading : l.uploadLogo })), isPro && _jsx("input", { ref: fileInputRef, type: "file", accept: "image/png,image/jpeg,image/svg+xml,image/webp", style: { display: 'none' }, onChange: handleLogoUpload }), _jsx("div", { className: styles.hint, children: l.logoHint })] }), _jsxs("div", { className: styles.card, children: [_jsx("div", { className: styles.label, children: t.companyName }), _jsx("input", { className: styles.input, value: isPro ? companyName : 'Design Studio', onChange: function (e) { return isPro && setCompanyName(e.target.value); }, readOnly: !isPro, tabIndex: isPro ? 0 : -1 }), _jsx("div", { className: styles.hint, children: t.shownInPortal })] })] }), _jsxs("div", { className: styles.card, style: { marginBottom: 16 }, children: [_jsx("div", { className: styles.label, children: l.brandColor }), _jsxs("div", { className: styles.colorRow, children: [BASIC_COLORS.map(function (c) { return _jsx("button", { className: "".concat(styles.colorDot, " ").concat(brandColor === c ? styles.colorDotActive : ''), style: { background: c }, onClick: function () { return isPro && setBrandColor(c); }, tabIndex: isPro ? 0 : -1 }, c); }), isPro && _jsx("input", { type: "color", value: isGradient ? '#6366f1' : brandColor, onChange: function (e) { return setBrandColor(e.target.value); }, className: styles.colorPicker, title: l.customColor })] })] }), _jsxs("div", { className: styles.card, style: { marginBottom: 20 }, children: [_jsxs("div", { className: styles.label, children: [t.gradients, _jsx("span", { className: styles.proTag, children: "PRO" })] }), _jsx("div", { className: styles.gradientGrid, children: PRO_GRADIENTS.map(function (g) { return _jsx("button", { className: "".concat(styles.gradientSwatch, " ").concat(brandColor === g.value ? styles.gradientSwatchActive : ''), style: { background: g.value }, onClick: function () { return isPro && setBrandColor(g.value); }, tabIndex: isPro ? 0 : -1, title: g.id }, g.id); }) })] }), _jsx("div", { className: styles.previewLabel2, children: l.preview }), _jsxs("div", { className: styles.previewBar, style: { background: isPro ? brandColor : 'linear-gradient(135deg, #4facfe, #00f2fe)' }, children: [isPro && logoUrl && _jsx("img", { src: logoUrl, alt: "", className: styles.previewLogo }), !isPro && _jsx("div", { className: styles.previewLogoMock, children: "LOGO" }), _jsx("span", { className: styles.previewText, children: isPro ? (companyName || t.companyName) : 'Design Studio' })] }), isPro && (_jsx("div", { className: styles.saveRow, children: _jsx("button", { className: styles.saveBtn, onClick: handleSave, disabled: saving, children: saving ? t.saving : saved ? "\u2705 ".concat(t.saved) : "\uD83D\uDCBE ".concat(t.save) }) }))] })] })] }));
};
